import "./App.css"; //import BasicRating from './pruebas.components';
//import DashBoard from './dashboard.page';
import RnpDash from "./Modules/RNP/dash.page.jsx";
import RnpConsultas from "./Modules/RNP/consultas.page";
import UsersDash from "./Modules/Usuarios/usuariosDash.page";
import UsersUsuarios from "./Modules/Usuarios/users.page";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import MiniDrawer from "./Components/Nav";
import SignInSide from "./Modules/Login/login";
import RnpHistorial from "./Modules/RNP/historial";
import RootLayout from "./Modules/Main.jsx";
import SessionContextProvider, {
  ContextSession,
} from "./services/ContextSession.jsx";
import { useContext, useEffect } from "react";
import ConsultaDifuntos from "./Modules/RNP/consulta_difuntos.jsx";
import ConsultaActasMatrimonio from "./Modules/RNP/consulta_actasmatrimonio.jsx";
import ArbolGenealogico from "./Modules/RNP/consulta_Arbol.jsx";
import ConsultaPorNombre from "./Modules/RNP/consulta_nombres.jsx";
import { TimerProvider } from "./services/ContextTimer";
import { ThemeProvider } from "@mui/material/styles";
import ThemeService from "./services/theme.service";
import ResumenSeparacion from "./Modules/Separaciones/datos_caso1.jsx";
import ListaSeparaciones from "./Modules/Separaciones/lista.jsx";
import Resumen from "./Modules/Separaciones/tabs caso 1/resumen.jsx";
import TablaDeInteres from "./Modules/Separaciones/tabs caso 1/tabladeinteres.jsx";
import TasasPorAno from "./Modules/Separaciones/tabs caso 1/tasasporano.jsx";
import MontoDelBeneficio from "./Modules/Separaciones/tabs caso 1/montodelbeneficio.jsx";
import Datos from "./Modules/Separaciones/tabs caso 1/datos.jsx";
import Calculos from "./Modules/Separaciones/tabs caso 1/calculos.jsx";
import TablaDeInteresLeyAnterior from "./Modules/Separaciones/tabs caso 2/tabladeinteres_la.jsx";
import TasasPorAnoLeyAnterior from "./Modules/Separaciones/tabs caso 2/tasasporano_la.jsx";
import MontoDelBeneficioLeyAnterior from "./Modules/Separaciones/tabs caso 2/montodelbeneficio_la.jsx";
import ResumenLeyAnterior from "./Modules/Separaciones/tabs caso 2/resumen_la.jsx";
import DatosLeyAnterior from "./Modules/Separaciones/tabs caso 2/datos_la.jsx";
import CalculosLeyAnterior from "./Modules/Separaciones/tabs caso 2/calculos_la.jsx";
import RO13demayo2014 from "./Modules/Separaciones/datos_caso3.jsx";
import ROantes13demayo2014 from "./Modules/Separaciones/datos_caso4.jsx";
import LeyAnterior from "./Modules/Separaciones/datos_caso2.jsx";

import RetirosDeOficioRoActual from "./Modules/Separaciones/tabs caso 3/retirosdeoficio.jsx";
import CalculosRoActual from "./Modules/Separaciones/tabs caso 3/calculos.jsx";
import MontoDelBeneficioRoActual from "./Modules/Separaciones/tabs caso 3/montodelbeneficio.jsx";
import ResumenRoActual from "./Modules/Separaciones/tabs caso 3/resumen.jsx";
import TablaDeInteresRoActual from "./Modules/Separaciones/tabs caso 3/tabladeinteres.jsx";
import TasasPorAnoRoActual from "./Modules/Separaciones/tabs caso 3/tasasporano.jsx";
import RebajasLeyAnterior from "./Modules/Separaciones/tabs caso 2/rebajas_la.jsx";
import PeriodosLeyAnterior from "./Modules/Separaciones/tabs caso 2/periodos_la.jsx";
import ComparativaLeyAnterior from "./Modules/Separaciones/tabs caso 2/comparativadev_la.jsx";
import ConReingresoLeyAnterior from "./Modules/Separaciones/tabs caso 2/conreingreso_la.jsx";
import ComparativaROAnterior from "./Modules/Separaciones/tabs caso 4/comparativadev_ROanterior.jsx";
import FiniquitoROAnterior from "./Modules/Separaciones/tabs caso 4/finiquito_ROanterior.jsx";
import RebajasROAnterior from "./Modules/Separaciones/tabs caso 4/rebajas_ROanterior.jsx";
import PeriodosROAnterior from "./Modules/Separaciones/tabs caso 4/periodos_ROanterior.jsx";
import CalculosROAnterior from "./Modules/Separaciones/tabs caso 4/calculos_ROanterior.jsx";
import TablaDeInteresROAnterior from "./Modules/Separaciones/tabs caso 4/tabladeinteres_ROanterior.jsx";
import ResumenROAnterior from "./Modules/Separaciones/tabs caso 4/resumen_ROanterior.jsx";
import EmpleadosDash from "./Modules/Portal del Participante/Préstamos/lista_solicitudes.jsx";
import CrearUsuarios from "./Modules/Portal del Participante/Préstamos/crear_usuarios.jsx";
import AsignarSolicitudes from "./Modules/Portal del Participante/Préstamos/asignar_solicitudes.jsx";
import SolicitudCarga from "./Modules/Portal del Participante/Préstamos/solicitud_carga.jsx";
import ListaQuejasSugerencias from "./Modules/Portal del Participante/UDI/lista_Quejas.jsx";
import VerQuejasSugerencias from "./Modules/Portal del Participante/UDI/ver_Quejas.jsx";
import SolicitudCargaSimplificada from "./Modules/Portal del Participante/Préstamos/solicitud_carga_simplificada.jsx";
import SignInSide2 from "./Modules/Login/loginPortal.jsx";
import EnviarMensaje from "./Modules/Portal del Participante/Relaciones Publicas/buzon_entrada.jsx";
import BuscarIdentidad from "./Modules/Portal del Participante/Call Center/activar_fedevida.jsx";
import UnderConstruction from "./Components/UnderConstruction";

import PlanificacionDash from "./Modules/Planificacion/dash.jsx";
import PlanificacionPei from "./Modules/Planificacion/pei.jsx";
import PlanificacionPoa from "./Modules/Planificacion/poa.component.jsx";
import PoaDetalle from "./Modules/Planificacion/poaDetalle.jsx";
import CrearUsuarios360 from "./Modules/UTI/crear_usuarios360.jsx";
import As400 from "./Modules/UTI/as400.jsx";
import BlacklistPage from "./Modules/UTI/blacklist.jsx";
import Dominios from "./Modules/UTI/dominios.jsx";
import ModuleHome from "./Modules/ModuleHome.jsx";
import RouteResolver from "./Modules/RouteResolver.jsx";
import ActualizarDatos from "./Modules/Portal del Participante/Control De Ingresos/actualizar_datos.jsx";
import SolicitudCambioDatos from "./Modules/Portal del Participante/Call Center/solicitudes_actualizar_datos.jsx";
import ActualizarCorreos from "./Modules/Portal del Participante/Préstamos/actualizar_correos.jsx";
import EstadosPreanalisis from "./Modules/Portal del Participante/Call Center/estados_preanalisis.jsx";
import ReversionPatronal from "./Modules/Operaciones/reversion_patronal.jsx";
import ReversionesAplicadas from "./Modules/Operaciones/reversiones_aplicadas.jsx";
import ReversionesRechazadas from "./Modules/Operaciones/reversiones_rechazadas.jsx";
import ConfigConstanciasHistorial from "./Modules/Operaciones/ConfigHistorial.jsx";
import AsignarAgentesChatBot from "./Modules/Portal del Participante/Call Center/asignar_agenteschatbot.jsx";
import ConsultasChatBot from "./Modules/Portal del Participante/Call Center/consultas_chatbot.jsx";
import VerConsultaChat from "./Modules/Portal del Participante/Call Center/ver_consulta.jsx";
import ReasignarPreanalisis from "./Modules/Portal del Participante/Préstamos/reasignar.jsx";
import TablaVerConversaciones from "./Modules/Portal del Participante/Call Center/tabla_ver_conversaciones.jsx";
import VerConsultaChatJefe from "./Modules/Portal del Participante/Call Center/ver_consulta_jefe.jsx";
import EnviarMensajeTexto from "./Modules/Portal del Participante/Relaciones Publicas/mensajes_texto.jsx";
import Estadisticas from "./Modules/Portal del Participante/Call Center/estadisticas.jsx";
import ContratosPendientes from "./Modules/Portal del Participante/Control De Ingresos/contratos_pendientes.jsx";
import HistorialPreanalisis from "./Modules/Portal del Participante/Préstamos/historial_preanalisis.jsx";
import HistorialPreanalisSolicitudCargaJefe from "./Modules/Portal del Participante/Préstamos/solicitud_carga_jefe.jsx";
import ReversionesPendientes from "./Modules/Operaciones/reversiones_pendientes.jsx";
import ListaEstadosDeCuenta from "./Modules/Operaciones/ListaEstadosDeCuenta.jsx";
import EstadoDeCuenta from "./Modules/Operaciones/EstadoDeCuenta.jsx";
import DesglosePlanillas from "./Modules/Planillas/DesglosePlanillas.jsx";

import ListaCitasDomiciliarias from "./Modules/Sociales/solicitudes_citas.jsx";
import EstadosVisitasCallCenter from "./Modules/Portal del Participante/Call Center/estados_visitasVida.jsx";
import ListaCitasDomiciliariasCallCenterJefe from "./Modules/Portal del Participante/Call Center/solicitudes_citas.jsx";
import VerFormularioCitaCallCenterScreen from "./Modules/Portal del Participante/Call Center/ver_citadomiciliaria.jsx";
import VerFormularioCitaScreen from "./Modules/Sociales/ver_cita.jsx";
import ListaVerificacionesFeVida from "./Modules/Portal del Participante/Call Center/verificaciones_fevida.jsx";
import ListaSolConstanciasSG from "./Modules/Portal del Participante/Secretaría General/lista_solicitudesConstancias.jsx";
import AsignarConstanciaOperaciones from "./Modules/Portal del Participante/Operaciones/asignar_constaciaOP.jsx";
import ListaSolicitudesConsAnalistaOP from "./Modules/Portal del Participante/Operaciones/lista_constanciasAnalista.jsx";
import VerSolConstanciaOperaciones from "./Modules/Portal del Participante/Operaciones/ver_solConstancia.jsx";
import ListaSolConstanciasAprobadasSG from "./Modules/Portal del Participante/Secretaría General/lista_solicitudesConstanciasAprobadas.jsx";
import ListaSolConstanciasSubSanandoSG from "./Modules/Portal del Participante/Secretaría General/lista_solicitudesConstanciasSubSanando.jsx";

import CrearCargaTgu from "./Modules/Legal/Carga Administrativa/CrearCargaTgu.jsx";
import ListaCargaTgu from "./Modules/Legal/Carga Administrativa/ListaCargaTgu.jsx";
import ProximosTramitesTgu from "./Modules/Legal/Carga Administrativa/ProximasTramitesTgu.jsx";
import CrearCargaSps from "./Modules/Legal/Carga Administrativa/CrearCargaSps.jsx";
import ListaCargaSps from "./Modules/Legal/Carga Administrativa/ListaCargaSps.jsx";
import ProximosTramitesSps from "./Modules/Legal/Carga Administrativa/ProximosTramitesSps.jsx";
import VerSolConstanciaSG from "./Modules/Portal del Participante/Secretaría General/ver_solConstanciaSG.jsx";

import DetallesTgu from "./Modules/Legal/Carga Administrativa/DetallesTgu.jsx";
import DetallesSps from "./Modules/Legal/Carga Administrativa/DetallesSps.jsx";
import ListaCargaJefe from "./Modules/Legal/Carga Administrativa/ListaCargaJefe.jsx";
import ListaCargaJefeSps from "./Modules/Legal/Carga Administrativa/ListaCargaJefeSps.jsx";
import MonitoreoTramites from "./Modules/Legal/Carga Administrativa/MonitoreoTramites.jsx";
import MonitoreoTramiteSps from "./Modules/Legal/Carga Administrativa/MonitoreoTramiteSps.jsx";
import DetallesJefe from "./Modules/Legal/Carga Administrativa/DetallesJefe.jsx";
import DetallesJefeSps from "./Modules/Legal/Carga Administrativa/DetallesJefeSps.jsx";

import ListaUsuarios from "./Modules/UTI/usuarios.jsx";
import UserProfile from "./Modules/UTI/usuarioEdit.jsx";

//flotas
import RegistroVehiculos from "./Modules/Flotas/RegistroVehiculos.jsx";
import ProximosMantenimientos from "./Modules/Flotas/ProximosMantenimientos.jsx";
import RegistrarMantenimiento from "./Modules/Flotas/RegistrarMantenimiento.jsx";
import MantenimientoCorrectivo from "./Modules/Flotas/MantenimientoCorrectivo.jsx";
import GestionDePases from "./Modules/Flotas/GestionDePases.jsx";
import RegistroPases from "./Modules/Flotas/RegistroPases.jsx";
import DetallesPaseSalida from "./Modules/Flotas/DetallesPaseSalida.jsx";
import ListaPases from "./Modules/Flotas/ListaPases.jsx";
import HistorialMantenimientos from "./Modules/Flotas/HistorialMantenimientos.jsx";
import GestionConductores from "./Modules/Flotas/GestionConductores.jsx";
import GestionTalleres from "./Modules/Flotas/GestionTalleres.jsx";
import GestionRutas from "./Modules/Flotas/GestionRutas.jsx";
import DetallesMantenimiento from "./Modules/Flotas/DetallesMantenimiento.jsx";
import ReporteriaPases from "./Modules/Flotas/ReporteriaPases.jsx";
import ReporteMantenimiento from "./Modules/Flotas/ReporteMantenimiento.jsx";

import ListaSolConstanciasCallCenter from "./Modules/Portal del Participante/Call Center/listaConstanciasCallCenter.jsx";
import ListaSolConstanciasEntrega from "./Modules/Portal del Participante/EntregaConstancias/lista_solicitudesConstanciasEntrega.jsx";
import VerSolConstanciaEntrega from "./Modules/Portal del Participante/EntregaConstancias/ver_solConstanciaEntrega.jsx";
import VerSolConstanciaAsignador from "./Modules/Portal del Participante/Operaciones/ver_solConstancia_Asignador.jsx";
import ListaSolConstanciasRevisionCC from "./Modules/Portal del Participante/ConstanciasRevisionCC/lista_solicitudesConstanciasCC.jsx";
import ListaSolConstanciasSubSanandoCC from "./Modules/Portal del Participante/ConstanciasRevisionCC/lista_solicitudesConstanciasSubSanando.jsx";
import VerSolConstanciaCC from "./Modules/Portal del Participante/ConstanciasRevisionCC/ver_solConstanciaCC.jsx";
import EncuestasPage from "./Modules/Portal del Participante/Call Center/encuesta.jsx";
import EncuestasEncargadoPage from "./Modules/Portal del Participante/Call Center/encuestaEncargado.jsx";

import CrearDemanda from "./Modules/Legal/CrearDemanda.jsx";
import GestionPartes from "./Modules/Legal/GestionPartes.jsx";
import ProximasAcciones from "./Modules/Legal/ProximasAcciones.jsx";
import AccionesDemandaPage from "./Modules/Legal/AccionesDemandaPage.jsx";
import EditarRH from "./Modules/Legal/EditarRH.jsx";
import EditarSecretaria from "./Modules/Legal/EditarSecretaria.jsx";
import ListarPartes from "./Modules/Legal/ListarPartes.jsx";
import ListadoDeDemandas from "./Modules/Legal/ListadoDemandas.jsx";
import EditarDemanda from "./Modules/Legal/EditarDemanda.jsx";
import RecursosHumanos from "./Modules/Legal/RecursosHumanos.jsx";
import ReportesLegal from "./Modules/Legal/ReportesLegal.jsx";
import SecretariaLegal from "./Modules/Legal/SecretariaLegal.jsx";
import ReporteCnbs from "./Modules/Legal/ReporteCnbs.jsx";
import CrearDemandaSps from "./Modules/Legal/CrearDemandaSps.jsx";
import ListaDemandaSps from "./Modules/Legal/ListaDemandaSps.jsx";
import GestionPartesSps from "./Modules/Legal/GestionPartesSps.jsx";
import ListaPartesSps from "./Modules/Legal/ListaPartesSps.jsx";
import ProximasAccionesSps from "./Modules/Legal/ProximasAccionesSps.jsx";
import EditarDemandaSps from "./Modules/Legal/EditarDemandaSps.jsx";

import ReportePreanalisis from "./Modules/Portal del Participante/Préstamos/ReportePreanalisis.jsx";
import RegistrarAfiliacion from "./Modules/Enrolamiento/RegistrarAfiliacion.jsx";
import ActualizarDesignacion from "./Modules/Enrolamiento/ActualizarDesignacion.jsx";
import ConsultarDesignacion from "./Modules/Enrolamiento/ConsultarDesignacion.jsx";
import ActualizaDatosAfiliacion from "./Modules/Enrolamiento/ActualizaDatosAfiliacion.jsx";
import ConsultarDatosAfiliacion from "./Modules/Enrolamiento/ConsultarDatosAfiliacion.jsx";
import ImprimirDesignacion from "./Modules/Enrolamiento/ImprimirDesignacion.jsx";
import ImprimirFichaAfiliacion from "./Modules/Enrolamiento/ImprimirFichaAfiliacion.jsx";
import MenuMantenimiento from "./Modules/Enrolamiento/MenuMantenimiento.jsx";
import MenuConsultarDesignacion from "./Modules/Enrolamiento/MenuConsultarDesignacion.jsx";
import ColoniasEnrolamiento from "./Modules/Enrolamiento/ColoniasEnrolamiento.jsx";
import CargosEnrolamiento from "./Modules/Enrolamiento/CargosEnrolamiento.jsx";
import EstadoCivilMantenimiento from "./Modules/Enrolamiento/EstadoCivilMantenimiento.jsx";
import GeneroEnrolamiento from "./Modules/Enrolamiento/GeneroEnrolamiento.jsx";
import FirmaEnrolamiento from "./Modules/Enrolamiento/FirmaEnrolamiento.jsx";
import ProfesionesOficiosEnrolamiento from "./Modules/Enrolamiento/ProfesionesOficiosEnrolamiento.jsx";
import MenuReporteria from "./Modules/Enrolamiento/MenuReporteria.jsx";
import DashboardEnrolamiento from "./Modules/Enrolamiento/DashboardEnrolamiento.jsx";
import ReporteProduccionEnrolamiento from "./Modules/Enrolamiento/ReporteProduccionEnrolamiento.jsx";
import ReporteProduccionResumenEnrolamiento from "./Modules/Enrolamiento/ReporteProduccionResumenEnrolamiento.jsx";
import ReporteProduccionUsuariosEnrolamiento from "./Modules/Enrolamiento/ReporteProduccionUsuariosEnrolamiento.jsx";
import ReporteUsuariosDetalleEnrolamiento from "./Modules/Enrolamiento/ReporteUsuariosDetalleEnrolamiento.jsx";
import FormatoFichaAfiliacionEnrolamiento from "./Modules/Enrolamiento/FormatoFichaAfiliacionEnrolamiento.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { path: "", element: <SignInSide2 /> }, // Ruta inicial modificada para SignInSide
      {
        element: <MiniDrawer />, // MiniDrawer aplicado a todas las rutas excepto la inicial
        children: [
          { path: "Login", element: <SignInSide2 /> }, // Ruta Login
          {
            path: "Inicio",
            children: [
              {
                path: "",
                children: [{ index: true, element: <ModuleHome /> }],
              },
            ],
          },
          {
            path: "RNP",
            children: [
              {
                path: "",
                children: [
                  { index: true, element: <RnpDash /> },
                  { path: "Consultas", element: <RnpConsultas /> },
                  { path: "ConsultaRNP", element: <RnpConsultas /> },
                  { path: "Difuntos", element: <ConsultaDifuntos /> },
                  { path: "Defunciones", element: <ConsultaDifuntos /> },
                  { path: "ArbolGenealogico", element: <ArbolGenealogico /> },
                  {
                    path: "ActasDeMatrimonio",
                    element: <ConsultaActasMatrimonio />,
                  },
                  {
                    path: "ActasMatrimonio",
                    element: <ConsultaActasMatrimonio />,
                  },
                  { path: "ConsultaNombres", element: <ConsultaPorNombre /> },
                  { path: "BusquedaPorNombre", element: <ConsultaPorNombre /> },
                ],
              },
            ],
          },
          {
            path: "Separaciones",
            children: [
              {
                children: [
                  { path: "ListadeSolicitudes", element: <ListaSeparaciones /> },
                  { path: "SeparacionLeyActual", element: <ResumenSeparacion /> },
                  { path: "SeparacionLeyAnterior", element: <LeyAnterior /> },
                  {
                    path: "ROLeyActual",
                    element: <RO13demayo2014 />,
                  },
                  {
                    path: "ROLeyAnterior",
                    element: <ROantes13demayo2014 />,
                  },

                  //CASO #1
                  { path: "Resumen", element: <Resumen /> },
                  { path: "TablaDeInteres", element: <TablaDeInteres /> },
                  { path: "Tasas", element: <TasasPorAno /> },
                  { path: "MontoDelBeneficio", element: <MontoDelBeneficio /> },
                  { path: "Calculos", element: <Calculos /> },

                  //CASO #2
                  {
                    path: "ResumenLeyAnterior",
                    element: <ResumenLeyAnterior />,
                  },
                  {
                    path: "TablaDeInteresLeyAnterior",
                    element: <TablaDeInteresLeyAnterior />,
                  },
                  {
                    path: "TasasLeyAnterior",
                    element: <TasasPorAnoLeyAnterior />,
                  },
                  {
                    path: "MontoDelBeneficioLeyAnterior",
                    element: <MontoDelBeneficioLeyAnterior />,
                  },
                  {
                    path: "RebajasLeyAnterior",
                    element: <RebajasLeyAnterior />,
                  },
                  {
                    path: "CalculosLeyAnterior",
                    element: <CalculosLeyAnterior />,
                  },
                  {
                    path: "PeriodosLeyAnterior",
                    element: <PeriodosLeyAnterior />,
                  },
                  {
                    path: "ComparativaLeyAnterior",
                    element: <ComparativaLeyAnterior />,
                  },
                  {
                    path: "ConReingresoLeyAnterior",
                    element: <ConReingresoLeyAnterior />,
                  },

                  //CASO #3
                  { path: "ResumenRoActual", element: <ResumenRoActual /> },
                  {
                    path: "TablaDeInteresRoActual",
                    element: <TablaDeInteresRoActual />,
                  },
                  { path: "TasasRoActual", element: <TasasPorAnoRoActual /> },
                  {
                    path: "MontoDelBeneficioRoActual",
                    element: <MontoDelBeneficioRoActual />,
                  },
                  { path: "CalculosRoActual", element: <CalculosRoActual /> },
                  {
                    path: "RetirosOficioRoActual",
                    element: <RetirosDeOficioRoActual />,
                  },

                  //CASO #4
                  {
                    path: "ComparativaROAnterior",
                    element: <ComparativaROAnterior />,
                  },
                  {
                    path: "FiniquitoROAnterior",
                    element: <FiniquitoROAnterior />,
                  },
                  { path: "RebajasROAnterior", element: <RebajasROAnterior /> },
                  {
                    path: "PeriodosROAnterior",
                    element: <PeriodosROAnterior />,
                  },
                  {
                    path: "CalculosROAnterior",
                    element: <CalculosROAnterior />,
                  },
                  {
                    path: "TablaDeInteresROAnterior",
                    element: <TablaDeInteresROAnterior />,
                  },
                  { path: "ResumenROAnterior", element: <ResumenROAnterior /> },
                ],
              },
            ],
          },
          {
            path: "PortalDelParticipante",
            children: [
              {
                children: [
                  {
                    path: "Solicitudes",
                    element: <EmpleadosDash />,
                  },
                  { path: "CrearUsuario", element: <CrearUsuarios /> },
                  {
                    path: "SolicitudesActualizacionDeDatos",
                    element: <SolicitudCambioDatos />,
                  },
                  { path: "ActualizarDatos", element: <ActualizarDatos /> },
                  { path: "AsignarSolicitud", element: <AsignarSolicitudes /> },
                  { path: "SolicitudesCarga", element: <SolicitudCarga /> },
                  {
                    path: "SolicitudesCargaPreAnalisis",
                    element: <SolicitudCargaSimplificada />,
                  },
                  {
                    path: "ReportePreanalisis",
                    element: <ReportePreanalisis />,
                  },
                  {
                    path: "SolicitudesCargaPreAnalisisJefe",
                    element: <HistorialPreanalisSolicitudCargaJefe />,
                  },
                  {
                    path: "QuejasySugerencias",
                    element: <ListaQuejasSugerencias />,
                  },
                  {
                    path: "VerQuejasSugerencias",
                    element: <VerQuejasSugerencias />,
                  },
                  { path: "BuzonDeEntrada", element: <EnviarMensaje /> },
                  { path: "MensajesdeTexto", element: <EnviarMensajeTexto /> },
                  {
                    path: "SolicitudesCambioDatos",
                    element: <SolicitudCambioDatos />,
                  },
                  {
                    path: "ActualizarCorreoElectronico",
                    element: <ActualizarCorreos />,
                  },
                  {
                    path: "EstadosSolicitudesdePreanalisis",
                    element: <EstadosPreanalisis />,
                  },
                  {
                    path: "AsignarAgentesChatBot",
                    element: <AsignarAgentesChatBot />,
                  },
                  { path: "ConsultasChatBot", element: <ConsultasChatBot /> },
                  { path: "VerConsultaChatBot", element: <VerConsultaChat /> },
                  {
                    path: "VerConsultaChatBotJefe",
                    element: <VerConsultaChatJefe />,
                  },
                  {
                    path: "ReasignarSolicitud",
                    element: <ReasignarPreanalisis />,
                  },
                  {
                    path: "HistorialdePreanalisis",
                    element: <HistorialPreanalisis />,
                  },
                  {
                    path: "ConversacionesChatBot",
                    element: <TablaVerConversaciones />,
                  },
                  { path: "EstadisticasChatBot", element: <Estadisticas /> },
                  {
                    path: "ContratosPendientes",
                    element: <ContratosPendientes />,
                  },
                  { path: "ActivarFeDeVida", element: <BuscarIdentidad /> },
                  {
                    path: "EstadosVisitaDomiciliaria",
                    element: <EstadosVisitasCallCenter />,
                  },
                  {
                    path: "ListaVisitasDomiciliarias",
                    element: <ListaCitasDomiciliariasCallCenterJefe />,
                  },
                  {
                    path: "VerCitaCompleta",
                    element: <VerFormularioCitaCallCenterScreen />,
                  },
                  {
                    path: "VerificacionesFedeVida",
                    element: <ListaVerificacionesFeVida />,
                  },
                  //CONSTANCIAS
                  {
                    path: "SolicitudesConstancias",
                    element: <ListaSolConstanciasSG />,
                  },
                  {
                    path: "ListaSolicitudesAprobadasSG",
                    element: <ListaSolConstanciasAprobadasSG />,
                  },
                  {
                    path: "SolicitudesConstanciasSubSanando",
                    element: <ListaSolConstanciasSubSanandoSG />,
                  },
                  {
                    path: "AsignarConstanciaaAnalista",
                    element: <AsignarConstanciaOperaciones />,
                  },
                  {
                    path: "ListaSolicitudesConstancias",
                    element: <ListaSolicitudesConsAnalistaOP />,
                  },
                  {
                    path: "RevisionConstanciasCarterayCobro",
                    element: <ListaSolConstanciasRevisionCC />,
                  },
                  {
                    path: "ConstanciasCarterayCobro",
                    element: <ListaSolConstanciasRevisionCC />,
                  },
                  {
                    path: "VerSolicitudConstanciaCC",
                    element: <VerSolConstanciaCC />,
                  },
                  {
                    path: "ConstanciasSubsanandoCarterayCobro",
                    element: <ListaSolConstanciasSubSanandoCC />,
                  },
                  {
                    path: "SubsanacionConstanciasCC",
                    element: <ListaSolConstanciasSubSanandoCC />,
                  },
                  {
                    path: "VerSolicitudConstancia",
                    element: <VerSolConstanciaOperaciones />,
                  },
                  {
                    path: "VerSolicitudConstanciaSG",
                    element: <VerSolConstanciaSG />,
                  },
                  {
                    path: "ListadeConstanciasparaEntregar",
                    element: <ListaSolConstanciasEntrega />,
                  },
                  {
                    path: "VerSolConstanciaEntrega",
                    element: <VerSolConstanciaEntrega />,
                  },
                  {
                    path: "VerSolConstanciaAsignador",
                    element: <VerSolConstanciaAsignador />,
                  },
                  {
                    path: "ListaSolicitudesdeConstancias",
                    element: <ListaSolConstanciasCallCenter />,
                  },
                  { path: "Encuestas", element: <EncuestasPage /> },
                  {
                    path: "EncuestasCallCenter",
                    element: <EncuestasEncargadoPage />,
                  },
                ],
              },
            ],
          },
          {
            path: "Planificacion",
            children: [
              { index: true, element: <PlanificacionDash /> },
              { path: "PEI", element: <PlanificacionPei /> },
              {
                path: "PlanEstrategicoInstitucionalPEI",
                element: <PlanificacionPei />,
              },
              {
                path: "POAI",
                children: [
                  {
                    index: true,
                    element: <PlanificacionPoa />,
                  },
                  {
                    path: "Detalle",
                    element: <PoaDetalle />,
                  },
                ],
              },
              { path: "PlanOperativoAnualPOA", element: <PlanificacionPoa /> },
            ],
          },
          {
            path: "Operaciones",
            children: [
              { path: "ReversionPatronal", element: <ReversionPatronal /> },
              { path: "CargarReversion", element: <ReversionPatronal /> },
              {
                path: "ReversionesAplicadas",
                element: <ReversionesAplicadas />,
              },
              {
                path: "HistorialReversionesSubidas",
                element: <ReversionesAplicadas />,
              },
              {
                path: "ReversionesRechazadas",
                element: <ReversionesRechazadas />,
              },
              {
                path: "ReversionesPendientes",
                element: <ReversionesPendientes />,
              },
              {
                path: "ConfiguracionEstadoCuenta",
                element: <ConfigConstanciasHistorial />,
              },
              {
                path: "ListaEstadosDeCuenta",
                element: <ListaEstadosDeCuenta />,
              },
              {
                path: "EstadoDeCuenta",
                element: <EstadoDeCuenta />,
              },
            ],
          },
          {
            path: "Planillas",
            children: [
              { index: true, element: <DesglosePlanillas /> },
              { path: "Planillas", element: <DesglosePlanillas /> },
              { path: "MenuPlanillas", element: <DesglosePlanillas /> },
              { path: "CargarDesglose", element: <DesglosePlanillas /> },
              { path: "Desglose", element: <DesglosePlanillas /> },
            ],
          },
          {
            path: "Sociales",
            children: [
              {
                path: "ListaVisitasDomiciliarias",
                element: <ListaCitasDomiciliarias />,
              },
              {
                path: "SolicitudesVisitaDomiciliaria",
                element: <ListaCitasDomiciliarias />,
              },
              {
                path: "VerSolicitudCita",
                element: <VerFormularioCitaScreen />,
              },
            ],
          },
          {
            path: "Legal",
            children: [
              { path: "CrearDemanda", element: <CrearDemanda /> },
              { path: "ListadeDemandas", element: <ListadoDeDemandas /> },
              { path: "CrearParte", element: <GestionPartes /> },
              { path: "ListadePartes", element: <ListarPartes /> },
              { path: "ProximasAudiencias", element: <ProximasAcciones /> },
              { path: "AccionesDemanda", element: <AccionesDemandaPage /> },
              { path: "EditarDemanda", element: <EditarDemanda /> },
              { path: "EditarDemandaSps", element: <EditarDemandaSps /> },
              { path: "Reportes", element: <ReportesLegal /> },
              { path: "ReporteCnbs", element: <ReporteCnbs /> },
              { path: "RecursosHumanos", element: <RecursosHumanos /> },
              { path: "EditarRH", element: <EditarRH /> },
              { path: "EditarSecretaria", element: <EditarSecretaria /> },
              { path: "SecretariaLegal", element: <SecretariaLegal /> },
              { path: "ListadeCargasAdministrativasSPS", element: <CrearDemandaSps /> },
              { path: "ListadeDemandasSPS", element: <ListaDemandaSps /> },
              { path: "ProximasAudienciasSPS", element: <ProximasAccionesSps /> },
              { path: "GestionPartesSps", element: <GestionPartesSps /> },
              { path: "ListaPartesSps", element: <ListaPartesSps /> },

              { path: "CrearCarga", element: <CrearCargaTgu /> },
              { path: "ListaCargaTGU", element: <ListaCargaTgu /> },
              { path: "detalles/:id", element: <DetallesJefe /> },
              { path: "detallestgu/:id", element: <DetallesTgu /> },
              { path: "ProximosTramitesTGU", element: <ProximosTramitesTgu /> },
              { path: "ListadeCargasAdministrativas", element: <ListaCargaJefe /> },
              { path: "ListaCargasSPS", element: <ListaCargaJefeSps /> },
              { path: "MonitoreodeTramites", element: <MonitoreoTramites /> },
              {path:"CrearParteSPS",element:<UnderConstruction/>},
              {path:"ListadePartesSPS",element:<UnderConstruction/>},
              { path: "CrearCargaSPS", element: <CrearCargaSps /> },
              { path: "ListaCargaSPS", element: <ListaCargaSps /> },
              { path: "ProximosTramitesSPS", element: <ProximosTramitesSps /> },
              { path: "detallesps/:id", element: <DetallesJefeSps /> },
              { path: "detallesSps/:id", element: <DetallesSps /> },
              { path: "MonitoreodeTramitesSPS", element: <MonitoreoTramiteSps /> },

              { path: 'CrearDemandaSPS', element: <CrearDemanda /> },
                 { path: 'TipoCasoSPS', element: <ListadoDeDemandas /> },
                 { path: 'GestionPartesSPS', element: <GestionPartes /> },
                 { path: 'ListarPartesSPS', element: <ListarPartes /> },
                 { path: 'ProximasAccionesSPS', element: <ProximasAcciones /> },
                 { path: 'AccionesDemandaSPS', element: <AccionesDemandaPage /> },
            ],
          },
          {
            path: "UTI",
            children: [
              {
                children: [
                  { path: "CrearUsuarios360", element: <CrearUsuarios360 /> },
                  { path: "CrearUsuariosi360", element: <CrearUsuarios360 /> },
                  {path: 'ActualizarUsuarios360', element: <UserProfile/>},
                  {path:"ListaUsuariosi360",element:<ListaUsuarios/>},
                  { path: "Dominio", element: <Dominios /> },
                  { path: "BlackList", element: <BlacklistPage /> },
                  { path: "As400", element: <As400 /> },
                  { path: "Office", element: <UnderConstruction/> },
                ],
              },
            ],
          },
          {
            path: "ServiciosGenerales",
            children: [
              { path: "RegistroVehiculos", element: <RegistroVehiculos /> },
              {
                path: "AlertasMantenimientos",
                element: <ProximosMantenimientos />,
              },
              {
                path: "RegistrarMantenimiento/:id",
                element: <RegistrarMantenimiento />,
              },
              {
                path: "RegistroMantenimientoCorrectivo",
                element: <MantenimientoCorrectivo />,
              },
              { path: "ListadePases", element: <ListaPases /> },
              {
                path: "DetallesPaseSalida/:id",
                element: <DetallesPaseSalida />,
              },
              { path: "GestionDePases", element: <GestionDePases /> },
              { path: "RegistrodePases", element: <RegistroPases /> },
              {
                path: "HistorialdeMantenimientos",
                element: <HistorialMantenimientos />,
              },
              {
                path: "DetallesMantenimiento/:id",
                element: <DetallesMantenimiento />,
              },
              { path: "GestiondeConductores", element: <GestionConductores /> },
              { path: "GestiondeTalleres", element: <GestionTalleres /> },
              { path: "GestiondeRutas", element: <GestionRutas /> },
              { path: "ReportesdePases", element: <ReporteriaPases /> },
              {
                path: "ReportedeMantenimiento",
                element: <ReporteMantenimiento />,
              },
            ],
          },
           {
            path: "Riesgos",
            children: [
              { path: "CrearProceso", element: <UnderConstruction /> }, 
              { path: "HistorialdeProcesos", element: <UnderConstruction /> }, 
              { path: "AsignaciondeAlertas", element: <UnderConstruction /> }, 
              { path: "Alertas", element: <UnderConstruction /> }, 
              { path: "Estadisticas", element: <UnderConstruction /> },  
              { path: "HistorialdeTransacciones", element: <UnderConstruction /> },
              { path: "GestiondeUmbrales", element: <UnderConstruction /> }, 
               { path: "MonitoreoPreventivo", element: <UnderConstruction /> }, 
               { path: "ListaPEP", element: <UnderConstruction /> }, 
               { path: "ListaRestrictiva", element: <UnderConstruction /> }, 
               { path: "PerfilParticipante", element: <UnderConstruction /> },
               { path: "PerfilLAFT", element: <UnderConstruction /> }, 
                
               
            ],
          },
          {
            path: "Enrolamiento",
            children: [
              { path: "RegistrarAfiliacion", element: <RegistrarAfiliacion /> },
              { path: "ActualizarDesignacion", element: <ActualizarDesignacion /> },
              { path: "ConsultarDesignacion", element: <ConsultarDesignacion /> },
              { path: "ConsultarDesignación", element: <ConsultarDesignacion /> },
              { path: "ActualizarDatosAfiliacion", element: <ActualizaDatosAfiliacion /> },
              { path: "ConsultarDatosAfiliacion", element: <ConsultarDatosAfiliacion /> },
              { path: "ConsultarEnrolamiento", element: <ConsultarDatosAfiliacion /> },
              {
                path: "ConsultarDatosEnrolamiento",
                element: <ConsultarDatosAfiliacion variant="full" />,
              },
              { path: "ImprimirDesignacion", element: <ImprimirDesignacion /> },
              { path: "ImprimirFichaAfiliacion", element: <ImprimirFichaAfiliacion /> },
              { path: "MenuConsultarDesignacion", element: <MenuConsultarDesignacion /> },
              { path: "MenuConsultarDesignación", element: <MenuConsultarDesignacion /> },
              { path: "MenuMantenimiento", element: <MenuMantenimiento /> },
              { path: "ColoniasEnrolamiento", element: <ColoniasEnrolamiento /> },
              { path: "CargosEnrolamiento", element: <CargosEnrolamiento /> },
              { path: "EstadoCivilMantenimiento", element: <EstadoCivilMantenimiento /> },
              { path: "GeneroEnrolamiento", element: <GeneroEnrolamiento /> },
              { path: "GéneroEnrolamiento", element: <GeneroEnrolamiento /> },
              { path: "FirmaEnrolamiento", element: <FirmaEnrolamiento /> },
              { path: "ProfesionesOficiosEnrolamiento", element: <ProfesionesOficiosEnrolamiento /> },
              { path: "MenuReporteria", element: <MenuReporteria /> },
              { path: "Menureporteria", element: <MenuReporteria /> },
              { path: "MenuReportería", element: <MenuReporteria /> },
              { path: "DashboardEnrolamiento", element: <DashboardEnrolamiento /> },
              { path: "ReporteProduccionEnrolamiento", element: <ReporteProduccionEnrolamiento /> },
              { path: "ReporteProducciónEnrolamiento", element: <ReporteProduccionEnrolamiento /> },
              { path: "ReporteProduccionResumenEnrolamiento", element: <ReporteProduccionResumenEnrolamiento /> },
              { path: "ReporteProducciónResumenEnrolamiento", element: <ReporteProduccionResumenEnrolamiento /> },
              { path: "ReporteUsuariosEnrolamiento", element: <ReporteProduccionUsuariosEnrolamiento /> },
              { path: "ReporteUsuariosDetalleEnrolamiento", element: <ReporteUsuariosDetalleEnrolamiento /> },
              { path: "FormatoFichaAfiliacionEnrolamiento", element: <FormatoFichaAfiliacionEnrolamiento /> },
                
               
            ],
          },
          {
            path: "Settings",
            children: [
              { index: true, element: <UsersDash /> },
              { path: "Usuarios", element: <UsersUsuarios /> },
              //{ path: 'Cerrar Sesión', element: <SignInSide/> },
            ],
          },
          {
            path: ":modulo/:menu/:submenu/:opcion",
            element: <RouteResolver />,
          },
          {
            path: ":modulo/:menu/:submenu",
            element: <RouteResolver />,
          },

        ],
      },
    ],
  },
]);

function App() {
  return (
    <ThemeProvider theme={ThemeService.theme}>
      <SessionContextProvider>
        <TimerProvider>
          <RouterProvider router={router} />
        </TimerProvider>
      </SessionContextProvider>
    </ThemeProvider>
  );
}

export default App;
